module.exports = __webpack_public_path__ + "img/question_gif.ffad3d54.gif";